var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayoutBoard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.288,
    height: 20.288,
    viewBox: "0 0 20.288 20.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1990",
    "data-name": "Group 1990",
    transform: "translate(-1060 -406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Incentives",
    transform: "translate(1060 406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M17.317,2.971A10.144,10.144,0,0,0,2.971,17.317,10.144,10.144,0,0,0,17.317,2.971ZM10.144,19.1A8.955,8.955,0,1,1,19.1,10.144,8.965,8.965,0,0,1,10.144,19.1Z",
    transform: "translate(0 0)",
    fill: "#048041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(7.003 3.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M180.512,102.131h-1.273a1.316,1.316,0,1,1,0-2.631h2.547a.594.594,0,1,0,0-1.189h-1.316V97a.594.594,0,0,0-1.189,0v1.316h-.042a2.5,2.5,0,1,0,0,5.009h1.273a1.316,1.316,0,0,1,0,2.631h-2.547a.594.594,0,1,0,0,1.189h1.315v1.316a.594.594,0,0,0,1.189,0v-1.316h.042a2.5,2.5,0,0,0,0-5.009Z",
    transform: "translate(-176.734 -96.401)",
    fill: "#048041"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutBoard);
export default __webpack_public_path__ + "static/media/PayoutBoard.959995f2e8b9bcb8feca8ab2d0ab7df9.svg";
export { ForwardRef as ReactComponent };